import { forwardRef } from 'react'

import DatePickerButton, {
  DatePickerButtonProps,
} from '../../buttons/DatePickerButton/DatePickerButton'

export type DatePickerInputProps = Omit<DatePickerButtonProps, 'title'> & {
  setOpen(isOpen: boolean): void
  title: string
}

const DatePickerInput = forwardRef<HTMLButtonElement, DatePickerInputProps>(
  ({ setOpen, title, ...props }, ref) => (
    <DatePickerButton
      {...props}
      buttonRef={ref}
      title={title}
      onClick={() => {
        setOpen(!props.active)
      }}
    />
  )
)

export default DatePickerInput
